export default __webpack_public_path__ + "static/media/enBanner.9c9d5b4c.png";